import loadable from "@loadable/component"
import { Navigate, RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"

const WithdrawalLayout = loadable(
  async () => import("~/features/finance/pages/WithdrawalLayout"),
  { fallback: <></> },
)
const WithdrawalPage = loadable(
  async () => import("~/features/finance/pages/WithdrawalView"),
  { fallback: <></> },
)
const FinancialReportLayout = loadable(
  async () => import("~/features/finance/pages/FinancialReportLayout"),
  { fallback: <></> },
)
const FinancialReportPage = loadable(
  async () => import("~/features/finance/pages/FinancialReportView"),
  { fallback: <></> },
)
const BolFinancialReportPage = loadable(
  async () => import("~/features/finance/pages/BOLFinancialReportView"),
  { fallback: <></> },
)
const FinancialTransactionsPage = loadable(
  async () => import("~/features/finance/pages/FinancialTransactionsView"),
  { fallback: <></> },
)

export const financeRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.finance,
    element: <Navigate replace to={APP_ROUTES.financialWithdrawals} />,
  },
  {
    path: APP_ROUTES.financialWithdrawals,
    element: <WithdrawalLayout />,
    children: [{ index: true, element: <WithdrawalPage /> }],
  },
  {
    path: APP_ROUTES.financialTransactions,
    element: <FinancialTransactionsPage />,
  },
  {
    path: APP_ROUTES.financialReports,
    element: <FinancialReportLayout />,
    children: [
      { index: true, element: <FinancialReportPage /> },
      {
        path: APP_ROUTES.financialBolReport,
        element: <BolFinancialReportPage />,
      },
    ],
  },
]
